/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1VenueOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_VENUE_ORDER_STATE_ENTITY_NAME = 'ixc.mutualfunds.v1.VenueOrder';
export const ixcMutualfundsV1VenueOrderStateEntity = new schema.Entity<IxcMutualfundsV1VenueOrderState>(IXC_MUTUALFUNDS_V1_VENUE_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'venueOrderId' });

